import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { data9_4 } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";

const { MonthPicker } = DatePicker;
const { TextArea } = Input;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            note: {
                note: ""
            },
            loadingSave: false,
            print: false
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
        // this.computeNum(this.state.data)
    }



    computeNum = (data) => {
        const numConvert = (num = 0) => {
            num = Number(num || "0")
            return num
        };

        data[5].system = data.reduce((a, b) => {
            if (b.name != 'Total') {
                a += numConvert(b.system)
            }
            return a
        }, 0);

        data[5].stock = data.reduce((a, b) => {
            if (b.name != 'Total') {
                a += numConvert(b.stock)
            }
            return a
        }, 0);

        data[5].system = (data[5].system).toFixed(0);
        data[5].stock = (data[5].stock).toFixed(0);

        for (let i = 0; i < 5; i++) {
            data[i].diff = (numConvert(data[i].stock) - numConvert(data[i].system)).toFixed(0);
        }

        data[5].diff = data.reduce((a, b) => {
            if (b.name != 'Total') {
                a += numConvert(b.diff)
            }
            return a
        }, 0);

        data[5].diff = (data[5].diff).toFixed(0);

        for (let i = 0; i < 6; i++) {
            data[i].percent = (numConvert(data[i].system) == 0 ? 0 : (numConvert(data[i].diff) / numConvert(data[i].system))).toFixed(4);
        }

        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(data9_4);
        let data = JSON.parse(dataBegin);
        this.getNote(date);
        fetch(`/_9_5_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }
            this.setState({ loading: false });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    getNote = (date) => {
        fetch(`/_9_5_1_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                this.setState({
                    note: { ...x.data[0] }
                });
            }
        }).catch(err => {
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        if (this.state.note) {
            this.onSaveNote([{ ...this.state.note, year, month }])
        }
        fetch('/add_9_5', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            message.error('保存失败' + JSON.stringify(err));
            console.error(err);
        })
    }

    onSaveNote = (data) => {
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_9_5_1', headres).then(x => x.json()).then(x => {
            if (x.status == 1) {
                // message.success(x.msg);
                return
            }
            message.error('备注保存失败：' + x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table9_5', 1.5, '9.50', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    onFillLastMonth = () => {
        if (this.state.data[0] && this.state.data[0].id) {
            message.error('当前月份数据已存在!')
            this.setState({ loading: false });
            return
        }
        this.setState({ loading: true, data: [] });
        const date = this.state.date;
        let data = JSON.parse(JSON.stringify(data9_4));
        fetch(`/_9_5_info?year=${moment(date).format('YYYY')}&month=${moment(date).subtract(1, 'month').format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data.map(v => {
                    delete v.id;
                    delete v.month;
                    delete v.year;
                    return v
                });
            };
            message.info('数据填充成功！');
            this.setState({ loading: false });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    render() {
        const data = this.state.data;
        const columns = [{
            title: 'Items 项目',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: <div>Amount<br />System 台账数</div>,
            dataIndex: 'system',
            key: 'system',
            align: "center",
            render: (text, record, index) => {
                if (index <= 4) {
                    return (
                        <div className="table-padding table-color-number">
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={0}
                                className="table_numInput"
                                defaultValue={text == 0 ? "" : text}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(0));
                                    this.onChange('system', value, index)
                                }}

                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    )
                }
            }
        }, {
            title: <div>Amount<br />Stock taken 盘点数</div>,
            dataIndex: 'stock',
            key: 'stock',
            align: "center",
            render: (text, record, index) => {
                if (index <= 4) {
                    return (
                        <div className="table-padding table-color-number">
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={0}
                                className="table_numInput"
                                defaultValue={text == 0 ? "" : text}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(0));
                                    this.onChange('stock', value, index)
                                }}

                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    )
                }
            }
        }, {
            title: <div>Diff 差异</div>,
            dataIndex: 'diff',
            key: 'diff',
            align: "center",
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`} >
                        {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </div>
                )
            }
        }, {
            title: '% 百分比',
            dataIndex: 'percent',
            align: "center",
            key: 'percent',
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`} >
                        {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                    </div>
                )
            }
        }, {
            title: <div>GM/DOF Comments<br />总经理及财务总监备注</div>,
            dataIndex: 'note',
            key: 'note',
            align: "center",
            render: (text, record, index) => {
                if (index <= 4) {
                    return (
                        <div className="table-padding table-color-number">
                            <Input
                                className="table_numInput"
                                defaultValue={text}
                                onBlur={(e) => {
                                    let data = this.state.data;
                                    data[index].note = e.target.value;
                                    this.setState({
                                        data
                                    });
                                }}

                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`} style={{ textAlign: "center" }}>
                            -
                        </div>
                    )
                }
            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table9_5">
                        <Row>9.5 FFE Site Inspection Summary 固定资产盘点汇总 (at least half-yearly)</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true,
                                        note: { note: "" }
                                    });
                                    this.getDateData(str)
                                }}
                            />
                            <Button
                                type="primary"
                                style={{ marginLeft: 10, display: this.state.print ? 'none' : '' }}
                                onClick={this.onFillLastMonth}
                            >填充上月数据</Button>
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                        <Row style={{ margin: "20px 0", }}>
                            <Row style={{ margin: "10px 0" }}>9.5.1 Please provide the action plan on the variance. 请提供针对以上差异的后续跟进报告。</Row>
                            {!this.state.loading || this.state.print ? <TextArea
                                autosize={{ minRows: 4 }}
                                placeholder="请输入备注！"
                                defaultValue={this.state.note.note}
                                onBlur={(e) => {
                                    this.setState({
                                        note: { ...this.state.note, note: e.target.value }
                                    });
                                }}
                            /> : null}
                        </Row>
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_9_5">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-5/index.js